import request from '../request';
let link = process.env.NODE_ENV == 'development' ? '/host' : process.env.API;
/*
  @ 获取oss上传图片token
*/
export const get_oss_token = data => {
  return request({
    url: `/v3/file_upload_token`,
    method: 'get',
    Authorization: true,
    data: {}
  })
}

// 获取行业列表-一二三级
export const getProfessionsTree = () => {
	return request({
		url: link + `/static/v2/professions/tree`,
		method: 'get',
		data:{}
	})
}
//根据关键字来搜索公司
export const getSearchCompany = (params) => {
  return request({
    url: link + `/static/v1/mixed_companies/augment`,
    method: 'get',
    params
  })
}
//根据关键字来搜索公司
export const getCardCompany = (token) => {
  return request({
    url: `/v3/companies/${token}`,
    method: 'get'
  })
}
//获取公司详情
export const getCompanyDetail = (token) => {
  return request({
    url: link + `/static/v2/companies/${token}?type=cv`,
    method: 'get'
  })
}
//获取公司内推数职位数
export const getCompanyNum = (params) => {
  return request({
    url: `/v3/companies/jobs_count`,
    method: 'get',
    params
  })
}

//获取学校 Tag
export const getSchollTags = (id) => {
  return request({
    url: link + `/static/v2/universities/${id}/university_tags`,
    method: 'get'
  })
}

// 获取隐私协议条款
export const getPrivacyInfoData = (params) => {
  return request({
    url: '/v3/privacy_info',
    method: 'get',
    params
  })
}
